import Vue from 'vue';

export default class ContractingStatusModerateDialogViewModel {
  private readonly view: Vue;

  readonly STEPS = [
    {
      step: 0,
      component: 'ContractingStatusModerateSignYourContract',
    },
    {
      step: 1,
      component: 'ContractingStatusModerateSignatureReceived',
    },
    {
      step: 2,
      component: 'ContractingStatusModerateRequestReceived',
    },
  ];

  current_step = 0;

  final_step = this.STEPS.length - 1;

  current_component = this.STEPS[this.current_step];

  public constructor(view: Vue) {
    this.view = view;
  }

  menu_steps = [1, 2, 3]

  get dynamic_width() {
    // eslint-disable-next-line no-nested-ternary
    return (this.view.$vuetify.breakpoint.xs) ? '100%' : (this.view.$vuetify.breakpoint.sm) ? '80%' : '40%';
  }

  setContractingStatus(status: string) {
    switch (status) {
      case 'endorsement_sent_to_sign':
        this.current_step = 0;
        break;
      case 'uploaded_endorsement_on_sftp':
        this.current_step = 1;
        break;
      case 'balance_transfer_in_process':
        this.current_step = 2;
        break;
      default:
        this.current_step = 0;
        break;
    }
    this.current_component = this.STEPS[this.current_step];
  }

  endProcess = () => {
    this.current_step = 0;
    this.current_component = this.STEPS[this.current_step];
    this.view.$emit('closeModal');
  }
}
